
import { onMaximize } from '../../../components/layers/widget/actions';

const MaximizeWidget = {
    name: 'maximizeWidget',
    exec: message => {
        onMaximize();
        return message.message;
    }
};

export default MaximizeWidget;
